import { Accordion, AccordionDetails, AccordionSummary, useTheme, withStyles, withTheme } from '@material-ui/core';
import { Box } from '@mui/material';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
    import classNames from 'classnames';
   import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
    
import { DELETE_PURPOSE_BUILT_FIELD_TEMPLATE_FAILURE, GET_PURPOSE_BUILT_FIELD_TEMPLATES_FAILURE, POST_PURPOSE_BUILT_FIELD_TEMPLATE_FAILURE, UPDATE_PURPOSE_BUILT_FIELD_TEMPLATE_FAILURE } from 'modules/clients/types';
import { updatePurposeBuiltFieldTemplate, getAllPurposeBuiltFieldTemplates, deletePurposeBuiltFieldTemplate, postPurposeBuiltFieldTemplate } from 'modules/clients/clients.actions';
import CrudTable from '../clients/details/crudTable.component';
import { useEnumColumns } from 'modules/common/enumTableColumn';

const styles = (theme) => {
  return {
    row: {
      backgroundColor: theme.palette.common.white
    },
    inputGroup: {
      display: 'inline-flex',
      justifyContent: 'space-between'
    },
    root: {
      maxWidth: 170,
      marginRight: 10
    },
    extRoot: {
      width: 115,
      marginRight: 10
    },
    primaryContactRow: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      width: '100%'
    },
    primaryText: {
      paddingTop: 12,
      paddingRight: 5
    },
    newRow: {
      display: 'flex',
      flexDirection: 'column',
      maxWidth: 1050
    }
  };
};

const ClientPurposeBuiltFieldsTable = props => {
  const theme = useTheme();
  const { fieldStatusColumn, fieldTypeColumn } = useEnumColumns();

    const [isOpen, setIsOpen] = useState(false);
    //const [isLoading, setIsLoading] = useState(false);
    
  //const [customFields, setCustomFields] = useState(clientCustomFields ? clientCustomFields.filter((s) => s.purpseBuiltFieldId !== null) : []);

  const fieldStatuses =
    props.fieldStatuses && props.fieldStatuses.length > 0
      ? props.fieldStatuses.filter(s => s.isActive === true)
      : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

    const fieldTypes =
    props.fieldTypes && props.fieldTypes.length > 0
      ? props.fieldTypes.filter(s => s.isActive === true)
      : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

    const fieldDepdendencies =
    props.fieldDepdendencies && props.fieldDepdendencies.length > 0
      ? props.fieldDepdendencies.filter(s => s.isActive === true)
      : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

    const fieldDepdendencyValues =
    props.fieldDepdendencyValues && props.fieldDepdendencyValues.length > 0
      ? props.fieldDepdendencyValues.filter(s => s.isActive === true)
      : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

  const adjustedColumns = [
    { accessorKey: 'fieldId', header: 'Field ID', type: 'text', required: true, size: 150, enableColumnDragging: false, enableColumnActions: false, enableResizing: false },
    { accessorKey: 'fieldLabel', header: 'Label', type: 'text', required: true, size: 150, enableColumnDragging: false, enableColumnActions: false, enableResizing: false },
    { ...fieldTypeColumn('fieldTypeId'), header: 'Type', type: 'dropdown-v2', options: fieldTypes, size: 70, required: true, enableColumnDragging: false, enableColumnActions: false, enableResizing: false },
    { ...fieldStatusColumn('fieldStatusId'), header: 'In Use', type: 'dropdown-v2', options: fieldStatuses, size: 70, required: true, enableColumnDragging: false, enableResizing: false },
    { accessorKey: 'isRequiredField', header: 'Required', type: 'checkbox', size: 70, Cell: ({ cell }) => cell.row.original.isRequiredField != null && cell.row.original.isRequiredField === true ? <p>Yes</p> : <p>No</p>, enableColumnDragging: false, enableColumnActions: false, enableResizing: false },  
    { accessorKey: 'isRequiredOnClientAuthForm', header: 'Is Required on Client Auth Form', type: 'checkbox', enableColumnDragging: false, enableColumnActions: false, enableResizing: false, hideInTable: true },
    { accessorKey: 'isRequiredOnIntakeForm', header: 'Is Required on Intake Form', type: 'checkbox', enableColumnDragging: false, enableColumnActions: false, enableResizing: false, hideInTable: true },
    { accessorKey: 'isRequiredOnInvoice', header: 'Is Required on Invoice', type: 'checkbox', enableColumnDragging: false, enableColumnActions: false, enableResizing: false, hideInTable: true },
    { accessorKey: 'isRequiredOnPayroll', header: 'Is Required on Payroll', type: 'checkbox', enableColumnDragging: false, enableColumnActions: false, enableResizing: false, hideInTable: true },
    { accessorKey: 'fieldListValues', header: 'Field List Values', type: 'notes', enableColumnDragging: false, enableColumnActions: false, enableResizing: false, hideInTable: true },
    { accessorKey: 'fieldNotes', header: 'Field Notes', type: 'notes', enableColumnDragging: false, enableColumnActions: false, enableResizing: false, hideInTable: true },
    { accessorKey: 'isFieldDependentOn', header: 'Dependent', type: 'checkbox', enableColumnDragging: false, enableColumnActions: false, enableResizing: false, hideInTable: true },  
    { accessorKey: 'fieldDependentOnId', header: 'Field Dependent On', type: 'dropdown-v2', options: fieldDepdendencies, enableColumnDragging: false, enableColumnActions: false, enableResizing: false, hideInTable: true },
    { accessorKey: 'fieldDependentOnValueId', header: 'Field Dependent On Value', type: 'dropdown-v2', options: fieldDepdendencyValues, enableColumnDragging: false, enableColumnActions: false, enableResizing: false, hideInTable: true },

];

  const updateRow = async (field, values) => {
    const id = field.original.purposeBuiltFieldTemplateId;

    values.purposeBuiltFieldTemplateId = id;

    let newValues = {
      ...values,
      modifiedBy: 1,
      modifiedOn: new Date()
    }

    const resp = await props.updatePurposeBuiltFieldTemplate(newValues);
    if (resp.type === UPDATE_PURPOSE_BUILT_FIELD_TEMPLATE_FAILURE) {
      return false;
    }
    else {
      const getResp = await props.getAllPurposeBuiltFieldTemplates();
      if (getResp.type === GET_PURPOSE_BUILT_FIELD_TEMPLATES_FAILURE) {
        return false;
      } else {
        return true;
      }
    }
  };

  const createRow = async (values) => {
    let newValues = {
      fieldId: values.fieldId,
      fieldLabel: values.fieldLabel,
      fieldTypeId: values.fieldTypeId,
      fieldStatusId: values.fieldStatusId,
      isRequiredField: values.isRequiredField ? values.isRequiredField : false,
      isRequiredOnClientAuthForm: values.isRequiredOnClientAuthForm ? values.isRequiredOnClientAuthForm : false,
      isRequiredOnIntakeForm: values.isRequiredOnIntakeForm ? values.isRequiredOnIntakeForm : false,
      isRequiredOnInvoice: values.isRequiredOnInvoice ? values.isRequiredOnInvoice : false,      
      isRequiredOnPayroll: values.isRequiredOnPayroll ? values.isRequiredOnPayroll : false,
      fieldListValues: values.fieldListValues,
      fieldNotes: values.fieldNotes,
      isFieldDependentOn: values.isFieldDependentOn ? values.isFieldDependentOn : false,
      fieldDependentOnId: values.fieldDependentOnId ? values.fieldDependentOnId : '00000000-0000-0000-0000-000000000000',
      fieldDependentOnValueId: values.fieldDependentOnValueId ? values.fieldDependentOnValueId : '00000000-0000-0000-0000-000000000000',
      addedBy: 1,
      addedOn: new Date(),
      modifiedBy: 1,
      modifiedOn: new Date()
    }
    const resp = await props.postPurposeBuiltFieldTemplate(newValues);
    if (resp.type === POST_PURPOSE_BUILT_FIELD_TEMPLATE_FAILURE) {
      return false;
    } else {
      const getResp = await props.getAllPurposeBuiltFieldTemplates();
      if (getResp.type === GET_PURPOSE_BUILT_FIELD_TEMPLATES_FAILURE) {
        return false;
      } else {
        return true;
      }
    }
  };

  const deleteRow = async (field) => {
    const id = field.original.purposeBuiltFieldTemplateId;
    const resp = await props.deletePurposeBuiltFieldTemplate(id);
    if (resp.type === DELETE_PURPOSE_BUILT_FIELD_TEMPLATE_FAILURE) {
      return false;
    } else {
      const getResp = await props.getAllPurposeBuiltFieldTemplates();
      if (getResp.type === GET_PURPOSE_BUILT_FIELD_TEMPLATES_FAILURE) {
        return false;
      } else {
        return true;
      }
    }
  };

  return (
  <Accordion
      expanded={isOpen}
      onChange={() => {
        setIsOpen(!isOpen);
      }}
      classes={{ root: classNames(props.classes.accordionStyleContacts) }}
    >
      <AccordionSummary
        expandIcon={
          <Box color={theme.palette.secondary.main}>
            <ExpandMoreIcon color="inherit" />
          </Box>
        }
      >
        <div className={props.classes.newRow}>
          <h2>Transferee Data - Standard Fields</h2>
        </div>
      </AccordionSummary>
      <AccordionDetails>
              <CrudTable 
                editingMode={'modal'} // Can be changed to 'row' to edit inline 
                columns={adjustedColumns} 
                rows={props.purposeBuiltFieldTemplates ? props.purposeBuiltFieldTemplates : []} 
                updateRow={updateRow} 
                createRow={createRow} 
                deleteRow={deleteRow} 
              />
      </AccordionDetails>
    </Accordion>
        
  );
}; 

ClientPurposeBuiltFieldsTable.propTypes = {
  classes: PropTypes.object.isRequired,
  //clientRecordId: PropTypes.number,
  formikProps: PropTypes.object.isRequired,
  internalUsers: PropTypes.array,
  //clientCustomFields: PropTypes.array,
};

const mapStateToProps = (state) => {
  const { fieldTypes, fieldStatuses, fieldDepdendencies, fieldDepdendencyValues } = state.enumerations.allEnums;
  return {
    fieldTypes: fieldTypes,
    fieldStatuses: fieldStatuses,
    fieldDepdendencies: fieldDepdendencies,
    fieldDepdendencyValues: fieldDepdendencyValues
  };
};
  
export default compose(
  withStyles(styles),
  withTheme,
  connect(mapStateToProps, {
    getAllPurposeBuiltFieldTemplates,
    postPurposeBuiltFieldTemplate,
    updatePurposeBuiltFieldTemplate,
    deletePurposeBuiltFieldTemplate
  }),
)(ClientPurposeBuiltFieldsTable);